<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15.293 10.293a1 1 0 011.414 0l10 10a1 1 0 01-1.414 1.414L16 12.414l-9.293 9.293a1 1 0 01-1.414-1.414l10-10z"/></svg>